export default __webpack_public_path__ + "static/conversation-dark-65dc14c32ed89221f07d62845d2cdd10.png";